// Recovered compiled webpack factory 32191. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { b: () => a });
  var n = r(23989);
  let a = () => {
    let e = (0, n.z)();
    return e?.activationStart ?? 0;
  };
}
